<main>
  <div class="success-card">
    <div class="success-icon">
      <div class="checkmark"></div>
    </div>
    <h1>Pagamento Concluído</h1>
    <p>Seu pagamento foi processado com sucesso. Obrigado pela sua assinatura!</p>

    <div class="order-details">
      <div class="detail-row">
        <span>Data</span>
        <span>{{hoje | date: 'dd/MM/yyyy'}}</span>
      </div>
      <div class="detail-row">
        <span>Método</span>
        <span>Cartão de crédito</span>
      </div>
    </div>

    <a href="/login" class="button">Voltar acessar palaforma</a>
  </div>
</main>
